module.exports = __webpack_public_path__ + "static/img/honor_6.32288f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/about/honor_6.jpg
// module id = RDgp
// module chunks = 0